import React from 'react';

import DynamicNoteForm from './DynamicNoteForm';

export default function GraphPreviewForm() {
    return (
        <DynamicNoteForm note="This block renders a live preview of the ecosystem network visualization. There is nothing to configure." />
    );
}
